import { render, staticRenderFns } from "./CustomFieldCreate.vue?vue&type=template&id=41c73b7c&"
import script from "./CustomFieldCreate.vue?vue&type=script&lang=js&"
export * from "./CustomFieldCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports